import React from "react";
import styled from "styled-components";
import OGReleaseDate from "./components/ogReleaseDate";
import { IVideoSchedule } from "types/videoData";
import ProposedDate from "./components/proposedDate";

interface IProps {
  schedule: IVideoSchedule;
  onChange: (schedule: IVideoSchedule) => void;
}
const StepThree = ({ schedule, onChange }: IProps) => {
  return (
    <Container>
      <OGReleaseDate
        date={schedule.originalReleaseDate || new Date()}
        setDate={(date) => {
          onChange({ ...schedule, originalReleaseDate: date });
        }}
      />
      <ProposedDate
        date={schedule.proposedReleaseDate || new Date()}
        setDate={(date) => {
          onChange({ ...schedule, proposedReleaseDate: date });
        }}
      />
    </Container>
  );
};

export default StepThree;

const Container = styled.div`
  width: 100%;
  position: relative;
`;
